module.exports = {
	"addDetail": "Ajouter des détails sur le lot",
	"linkInfo": "Modifier les informations sur le lot",
	"noDetails": "Aucun détail sur ce lot n'est fourni.",
	"lotLimit": "Vous avez atteint le nombre maximum de lots permis par encan avec votre abonnement actuel, qui est __lotLimit__.",
	"pictureLimit": "Vous avez atteint le nombre maximum de photos permises par lot avec votre abonnement actuel, qui est __pictureLimit__.",
	"lotCreate": {
		"header": "Créer un lot",
		"descriptionLabel": "Courte description",
		"lotCreated": "Lot __rank__ - __name__ ajouté à l'encan.",
		"lotPicturesLabel": "Photos",
		"namePlaceholder": "Nom du lot"
	},
	"cancel": {
		"cancel": "Annuler le lot",
		"confirm": "Êtes-vous certain de vouloir annuler ce lot? Vous allez perdre toutes les enchères effectuées jusqu'à présent. $t(general::cannotUndo)",
		"success": "Votre lot a été annulé avec succès! Les participants vont en être informés."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/oa-lot.json5
// module id = 1997
// module chunks = 6